/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Supplyairhumiditysetpoint3Inputs */



/**
* | output |
* | --- |
* | "Supply air humidity setpoint" |
*
* @param {Ahu_History_Key_Supplyairhumiditysetpoint3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_supplyairhumiditysetpoint3 = /** @type {((inputs?: Ahu_History_Key_Supplyairhumiditysetpoint3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Supplyairhumiditysetpoint3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Supply air humidity setpoint")
	return /** @type {LocalizedString} */ ("Consigne humidité air soufflé")
});
export { ahu_history_key_supplyairhumiditysetpoint3 as "ahu_history_key_supplyAirHumiditySetpoint" }